import Cookies from 'js-cookie';
import { throttle } from '../helpers';

let datRcPosition = document.querySelector('[data-rc-position]');
let dataCpcPosition = document.querySelector('[data-cpc-position]');
let dataCfPosition = document.querySelector('[data-cf-position]');

let calcPositionTop = function() {
    datRcPosition ? datRcPosition.style.top = (dataCpcPosition.getBoundingClientRect().top - dataCfPosition.getBoundingClientRect().top) + 'px' : null;
}

if(datRcPosition && dataCpcPosition && dataCfPosition) {
    window.addEventListener('resize', throttle(calcPositionTop, 200));
    calcPositionTop();
} else {
    console.log("Error in Cart.js - check if DOM element exist ");
}

$(document).on('ready', function() {
    var $form = $('.template-cart #cart-form');

    /////////// Removing cart parsley validation when updating cart
    $form.find('[type="submit"][name="update"]').on('mousedown', function(){
        $form.off('submit.Parsley');
    });

    $('#shopifyDummyChat_open').on('click', () => {
        var dummyChatIframe = document.querySelector("#dummy-chat-button-iframe"),
            shopifyChat = document.querySelector("#ShopifyChat");

        dummyChatIframe ? $(dummyChatIframe.contentWindow.document.getElementById("dummy-chat-button")).click() : null;
        shopifyChat ? $(shopifyChat.contentWindow.document.querySelector(".chat-toggle")).click() : null;
    });

    //Recently viewed section
    if(document.cookie.indexOf('RECENTLY_VIEWED') != -1) {
        var products_cookie = Cookies.get('RECENTLY_VIEWED').split(',');
        var search_q_partial = products_cookie.map(function(product) {
            if(product) {
                return 'handle:"' + product + '"';
            }
        });

        var search_query = '/search?q=' + search_q_partial.join('+OR+') + '&type=product';

        fetch(window.location.origin + search_query)
        .then(function (response) {
            if(response.ok) {
                return response.text();
            }
            throw new Error('Something went wrong:' + response.status + '-' + response.statusText);
        })
        .then(function (html){
            var html_parsed = new DOMParser().parseFromString(html, 'text/html');
            var products = html_parsed.getElementById('AjaxinateContainer').innerHTML;
            document.getElementById('recentlyViewed').innerHTML = products;
        })
        .catch((error) => {
            console.log(error);
        });
    }
    else {
        document.querySelector('.recently-viewed-container').style.display = 'none';
    }

    calcPositionTop();
});



